<script lang="ts">
  import { TwistStack, ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import ReduceColor from '$components/Accessibility/CheckboxControls/ReduceColor.svelte';
  import ReduceMotion from '$components/Accessibility/CheckboxControls/ReduceMotion.svelte';

  const responsiveVars = new ResponsiveVars()
    .addResponsive('line-height', { min: '130%', lg: '120%' })
    .addFluid('font-size', toFluidVarInput(14, 18))
    .toCSS();
</script>

<div class={responsiveVars}>
  <TwistStack direction="row" justify="space-evenly" align="center">
    <div class="accessibility-option">
      <ReduceColor color="gray-100" />
      <span class="accessibility-control-text">Reduce color</span>
    </div>
    <div class="accessibility-option">
      <ReduceMotion color="gray-100" />
      <span class="accessibility-control-text">Reduce motion</span>
    </div>
  </TwistStack>
</div>

<style lang="scss">
  .accessibility-option {
    display: flex;
    align-items: center;
    color: black;

    .accessibility-control-text {
      font-family: var(--font-family-primary);
      font-weight: 500;
      font-size: var(--font-size);
      line-height: var(--line-height);
      margin-left: 8px;
    }
  }
</style>
